import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import { styled, useThemeProps } from '../../../foundation';
import { CardHoverActionsStyle } from './styles';
import { RcCardHoverActionsClasses } from './utils';
var _RcCardHoverActions = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcCardHoverActions' });
    var classNameProp = props.className, visible = props.visible, rest = __rest(props, ["className", "visible"]);
    var className = useMemo(function () {
        var _a;
        return clsx(classNameProp, RcCardHoverActionsClasses.root, (_a = {},
            _a[RcCardHoverActionsClasses.visible] = visible,
            _a));
    }, [classNameProp, visible]);
    return React.createElement("div", __assign({}, rest, { ref: ref, className: className }));
});
var RcCardHoverActions = styled(_RcCardHoverActions)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), CardHoverActionsStyle);
RcCardHoverActions.defaultProps = {};
RcCardHoverActions.displayName = 'RcCardHoverActions';
export { RcCardHoverActions };
var templateObject_1;
